import { useEffect, useState } from "react";
import styled from "styled-components";
import Link from "next/link";
import { useRouter } from "next/router";

function StaticTabs(props) {
	const names = props.names ? props.names : "cat";
	const [catParams, setCatParams] = useState("");
	const router = useRouter();
	const { query } = router;
	const { cat } = router.query;
	const categories = cat;

	const handleUpdateQueryParam = (values) => {
		// Update the search params onChange
		const newQuery = { ...query };
		newQuery[names] = values;
		router.replace({
			query: newQuery,
		});
	};

	if (props.categories) {
		return (
			<TabsSearch>
				<div className="tabs">
					{props.categories.map((option, index) => {
						return (
							<div className={index >= 1 ? "m_none tab_none" : ""} key={index}>
								<button
									type="button"
									className={
										categories === option ||
										(option.toLowerCase() === "all" && categories === null)
											? "tab active"
											: "tab"
									}
									onClick={(e) => {
										props.setTabsValues && props.setTabsValues(option);
										console.log(option);
										handleUpdateQueryParam(option);
									}}
								>
									{" "}
									{option}{" "}
								</button>
							</div>
						);
					})}
				</div>
			</TabsSearch>
		);
	}
}

export default StaticTabs;

const TabsSearch = styled.section`
	overflow: auto;
	.tabs {
		max-width: 500px;
		width: 100%;
		display: flex;
		flex-wrap: no-wrap !important;
		overflow: auto;
	}
	@media (max-width: 414px) {
		.tabs {
			width: 700px;
		}
	}
	.container {
		margin-bottom: 20px;
	}
	.normal_tab {
		background: transparent;
	}

	.tabs {
		margin: 0;
		margin-bottom: 30px;
		@media (min-width: 768px) {
			width: 100%;
		}
		.tab {
			margin: 0;
			height: 45px;
			align-items: center;
			display: flex;
			justify-content: center;
			padding: 0;
			padding: 5px 10px;
			text-align: center;
			margin-right: 15px;
			button {
				margin: 0;
				padding: 0 !important;
				padding: 15px;
				font-size: 14px;
			}
		}
		.active {
			background: transparent;
			border-bottom: 2px solid #00838f;
			button {
				color: #00838f;
			}
		}
	}
	.normal_tab.add_tape {
		border-bottom: 2px solid yellow;
	}
	@media (min-width: 760px) {
		display: flex;
		justify-content: space-between;
	}
	@media (max-width: 500px) {
		.m_none {
			display: none !important;
		}
	}
	@media (max-width: 820px) {
		.tab_none {
			display: none !important;
		}
	}
	@media (max-width: 1112px) {
		.mid_none {
			display: none !important;
		}
	}
`;
